// Banque d'icônes (Material Icons) réutilisable — ex. bouton "retour à l'accueil" personnalisable (Lot 4 / C).
// Sélection axée navigation / culture / livres-bibliothèque + icônes "retour".
export const ICON_CATALOG = [
  // Accueil & navigation
  'home', 'arrow_back', 'keyboard_backspace', 'reply', 'undo', 'first_page',
  'map', 'explore', 'place', 'tour', 'near_me', 'signpost', 'navigation',
  // Culture & patrimoine
  'museum', 'account_balance', 'palette', 'brush', 'theater_comedy', 'music_note',
  'architecture', 'castle', 'monument', 'church',
  // Livres & savoir
  'menu_book', 'book', 'auto_stories', 'local_library', 'school', 'science', 'lightbulb',
  // Nature & divers
  'public', 'park', 'forest', 'landscape', 'star', 'favorite', 'info',
];
